/**
 * Delete Add-On Product API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../axiosInstance';

export const deleteAddOnProduct = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/api/add-on-products/${id}`);
};
